import { Card, CardBody, Col, Row } from 'reactstrap'
import AdditiveBorders from './AdditiveBorders'
import SubtractiveBorders from './SubtractiveBorders'
import AdditiveRadius from './AdditiveRadius'
import { BordersAndDisplays } from '../../../../Utils/Constants'
import { borderData } from '../../../../Data/Ui-Kits/HelperClasses/HelperClassesData'
import CardHeaderCommon from '../../../../Utils/CommonComponents/CardHeaderCommon'

const BorderCart = () => {
  return (
    <Col xs="12">
      <Card>
        <CardHeaderCommon title={BordersAndDisplays} span={borderData} headClass="card-no-border pb-0"/>
        <CardBody>
          <Row className="g-3">
            <AdditiveBorders />
            <SubtractiveBorders />
            <AdditiveRadius />
          </Row>
        </CardBody>
      </Card>
    </Col>
  )
}

export default BorderCart